import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../hooks/useQueryParams";

const LEGACY_CHECK_OPTIONS = [
  {
    id: "softcheck",
    name: "Softcheck",
  },
  {
    id: "equifax",
    name: "Equifax",
  },
  {
    id: "identity_verification",
    name: "Identity Verification",
  },
  {
    id: "enhanced_identity_verification",
    name: "Enhanced Identity Verification",
  },
  {
    id: "criminal_record_check",
    name: "Criminal Record Check",
  },
  {
    id: "enhanced_criminal_record_check",
    name: "Enhanced Criminal Record Check",
  },
  {
    id: "vulnerable_sector_criminal_record_check",
    name: "Vulnerable Sector Criminal Record Check",
  },
  {
    id: "international_criminal_record_check",
    name: "International Criminal Record Check",
  },
  {
    id: "international_criminal_record_check_access_fee",
    name: "International Criminal Record Check Access Fee",
  },
  {
    id: "motor_vehicle_records",
    name: "Motor Vehicle Records",
  },
  {
    id: "education_verification",
    name: "Education Verification",
  },
  {
    id: "international_education_verification",
    name: "International Education Verification",
  },
  {
    id: "credential_verification",
    name: "Credential Verification",
  },
  {
    id: "employment_verification",
    name: "Employment Verification",
  },
  {
    id: "us_criminal_base_check",
    name: "US Criminal Base Check",
  },
  {
    id: "us_criminal_single_state_county_check",
    name: "US Criminal Single State County Check",
  },
  {
    id: "us_criminal_all_state_county_check_7_year_search",
    name: "US Criminal All State County Check 7 Year Search",
  },
  {
    id: "us_criminal_all_state_county_check_10_year_search",
    name: "US Criminal All State County Check 10 Year Search",
  },
  {
    id: "us_criminal_access_fee",
    name: "US Criminal Access Fee",
  },
  {
    id: "employment_reference",
    name: "Employment Reference",
  },
  {
    id: "address_reference",
    name: "Address Reference",
  },
  {
    id: "employment_phone_reference",
    name: "Employment Phone Reference",
  },
  {
    id: "address_phone_reference",
    name: "Address Phone Reference",
  },
  {
    id: "instant_verify_education",
    name: "Instant Verify Education",
  },
  {
    id: "instant_verify_employment",
    name: "Instant Verify Employment",
  },
  {
    id: "instant_verify_credential",
    name: "Instant Verify Credential",
  },
  {
    id: "soquij",
    name: "SOQUIJ",
  },
  {
    id: "australian_criminal_intelligence_commission_check",
    name: "Australian Criminal Intelligence Commission Check",
  },
  {
    id: "volunteer_acic_check",
    name: "Volunteer ACIC Check",
  },
  {
    id: "right_to_work",
    name: "Right To Work",
  },
  {
    id: "uk_basic_dbs_check",
    name: "UK Basic DBS Check",
  },
  {
    id: "uk_basic_ds_check",
    name: "UK Basic DS Check",
  },
  {
    id: "uk_right_to_work_check",
    name: "UK Right To Work Check",
  },
  {
    id: "social_media_check",
    name: "Social Media Check",
  },
  {
    id: "base",
    name: "Base",
  },
  {
    id: "employer_reference",
    name: "Employer Reference",
  },
  {
    id: "us_criminal_record_check_tier_1",
    name: "US Criminal Record Check Tier 1",
  },
  {
    id: "us_criminal_record_check_tier_2",
    name: "US Criminal Record Check Tier 2",
  },
  {
    id: "us_criminal_record_check_tier_3",
    name: "US Criminal Record Check Tier 3",
  },
  {
    id: "vaccination_check",
    name: "Vaccination Check",
  },
  {
    id: "uk_credit_check",
    name: "UK Credit Check",
  },
  {
    id: "au_bankruptcy_check",
    name: "AU Bankruptcy Check",
  },
  {
    id: "au_directorship_check",
    name: "AU Directorship Check",
  },
  {
    id: "asic_banned_and_disqualified_persons_check",
    name: "ASIC Banned And Disqualified Persons Check",
  },
  {
    id: "australian_national_police_check",
    name: "Australian National Police Check",
  },
  {
    id: "us_upper_civil_check",
    name: "US Upper Civil Check",
  },
  {
    id: "international_financial_check",
    name: "International Financial Check",
  },
];

export function LegacyChecksFilter() {
  const { setParam, params } = useQueryParams();
  const { t } = useTranslation();

  return (
    <Picker
      showActionBar
      selectedKeys={params.checks?.split(",") || []}
      onSelectionChange={(keys) => setParam("checks", Array.from(keys))}
      label={t("Checks")}
      items={LEGACY_CHECK_OPTIONS}
      selectionMode="multiple"
      testID="legacy-checks-filter"
    />
  );
}
